export const createRawFromText = text => ({
	blocks: [{
		type: 'unstyled',
		text,
		inlineStyleRanges: [],
		entityRanges: [],
	}],
	entityMap: {},
});


// WEBPACK FOOTER //
// ./lib/helpers/createRawFromText.js